import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { resolveFormControlStateSchema } from '../../../utils/SchemaParser';

class InspectionFormContext extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
    formSchema: PropTypes.object.isRequired,
  };

  formControlStates = {};
  shouldStrictValidate = false;

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);

    this.formControlStates = resolveFormControlStateSchema(props.formSchema);
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState(this.getStateFromProps(nextProps));
    /*
    if(nextProps.isFormValid !== this.props.isFormValid) {
      this.setState({
        isFormValid: nextProps.isFormValid,
      })
    }
    */
  }

  getStateFromProps(props) {
    //const state = this.state || {};
    const errorsStrict = props.errorsStrict || [];
    const isFormValid = errorsStrict.length === 0;
    const { shouldStrictValidate } = this;
    return {
      ...props,
      isFormValid,
      shouldStrictValidate,
    };
  }

  onFormControlChange = key => {
    this.formControlStates[key].dirty = true;
  };

  onSign = () => {
    this.shouldStrictValidate = true;
    this.setState(this.getStateFromProps(this.props));
  }
/*
  onFormControlFocus = key => {
    this.formControlStates[key].touched = true;
  };

  onFormControlBlur = key => {
    //this.formControlStates[key].touched = true;
  };
*/
  render() {
    const passedContext = {
      ...this.state,
      onFormControlChange: this.onFormControlChange,
      onSign: this.onSign,
  //    onFormControlFocus: this.onFormControlFocus,
  //    onFormControlBlur: this.onFormControlBlur,
      formControlStates: this.formControlStates,
    };
    return <div>{this.props.render(passedContext)}</div>;
  }
}

export default withRouter(InspectionFormContext);


// WEBPACK FOOTER //
// ./src/modules/inspection/components/InspectionFormContext.js